// extracted by mini-css-extract-plugin
export default {"input":"EzqFYhcL1HJA5x6P_IOT"};